import { WebPlugin } from '@capacitor/core';
export class CFPaymentGatewayWeb extends WebPlugin {
    async doWebCheckoutPayment(webCheckoutPaymentObject) {
        console.log('DO_WEB_PAYMENT', webCheckoutPaymentObject);
        throw new Error('Cashfree Payment Gateway is not supported on web platform. Use it on mobile devices only.');
    }
    async doUPIPayment(upiCheckoutPaymentObjections) {
        console.log('DO_UPI_PAYMENT', upiCheckoutPaymentObjections);
        throw new Error('UPI Payment is not supported on web platform. Use it on mobile devices only.');
    }
    async doSubscriptionPayment(subscriptionCheckoutPaymentObject) {
        console.log('DO_SUBSCRIPTION_PAYMENT', subscriptionCheckoutPaymentObject);
        throw new Error('Subscription Payment is not supported on web platform. Use it on mobile devices only.');
    }
}
//# sourceMappingURL=web.js.map